export enum Market {
  Sweden = 'se',
  Denmark = 'dk',
  Netherlands = 'nl',
  Finland = 'fi',
  Belgium = 'be',
  Norway = 'no',
}

export enum MarketLanguageCodes {
  Sweden = 'sv-SE',
  Denmark = 'da-DK',
  Netherlands = 'nl-NL',
  Finland = 'fi-FI',
  Belgium = 'nl-BE',
  Norway = 'no-NO',
}

export enum SupportedLocales {
  SV_SE = 'sv-SE',
  DA_DK = 'da-DK',
  FI_FI = 'fi-FI',
  NL_NL = 'nl-NL',
  FR_NL = 'fr-NL',
  NL_BE = 'nl-BE',
  EN_BE = 'en-BE',
  EN_DK = 'en-DK',
  EN_FI = 'en-FI',
  EN_NL = 'en-NL',
  EN_SE = 'en-SE',
  EN_NO = 'en-NO',
  NO_NO = 'no-NO',
  FR_BE = 'fr-BE',
  PL_NL = 'pl-NL',
}

export enum Language {
  Swedish = 'sv',
  English = 'en',
  Finnish = 'fi',
  Dutch = 'nl',
  Danish = 'da',
  Norwegian = 'no',
  French = 'fr',
}

export enum EValidLoanComponents {
  loanAmount = 'loanAmount',
  orgNumber = 'orgNumber',
  phoneNumber = 'phoneNumber',
  loanTerm = 'loanTerm',
  loanCalculator = 'loanCalculator',
  emailAddress = 'emailAddress',
  termsAgreement = 'termsAgreement',
  bankIntegration = 'bankIntegration',
  loanPurpose = 'loanPurpose',
  documentUpload = 'documentUpload',
  personalNumber = 'personalNumber',
  turnover = 'turnover',
  text = 'text',
  thankYouMessage = 'thankYouMessage',
  rlcRedirect = 'rlcRedirect',
  header = 'header',
  next = 'next',
  previous = 'previous',
}

export enum EValidLoanComponentsNL {
  loanAmount = 'loanAmount',
  orgNumber = 'orgNumber',
  phoneNumber = 'phoneNumber',
  homeAddress = 'homeAddress',
  loanTerm = 'loanTerm',
  loanCalculator = 'loanCalculator',
  emailAddress = 'emailAddress',
  termsAgreement = 'termsAgreement',
  bankIntegration = 'bankIntegration',
  loanPurpose = 'loanPurpose',
  documentUpload = 'documentUpload',
  personalNumber = 'personalNumber',
  thankYouMessage = 'thankYouMessage',
  rlcRedirect = 'rlcRedirect',
  header = 'header',
  turnover = 'turnover',
  text = 'text',
  next = 'next',
  previous = 'previous',
}

export enum EValidCardComponents {
  orgNumber = 'orgNumber',
  phoneNumber = 'phoneNumber',
  emailAddress = 'emailAddress',
  termsAgreement = 'termsAgreement',
  bankIntegration = 'bankIntegration',
  documentUpload = 'documentUpload',
  personalNumber = 'personalNumber',
  homeAddress = 'homeAddress',
  turnover = 'turnover',
  website = 'website',
  text = 'text',
  thankYouMessage = 'thankYouMessage',
  rlcRedirect = 'rlcRedirect',
  next = 'next',
  previous = 'previous',
  cardPurpose = 'cardPurpose',
}

export enum ECardRequiredComponents {
  orgNumber = 'orgNumber',
  emailAddress = 'emailAddress',
  termsAgreement = 'termsAgreement',
  phoneNumber = 'phoneNumber',
  cardPurpose = 'cardPurpose',
  turnover = 'turnover',
}

export enum ELoanRequiredComponents {
  orgNumber = 'orgNumber',
  emailAddress = 'emailAddress',
  phoneNumber = 'phoneNumber',
  loanAmount = 'loanAmount',
  termsAgreement = 'termsAgreement',
}

export enum AppearanceMode {
  LIGHT = 'light',
  DARK = 'dark',
}
